import Vue from 'vue'
import Vuex from 'vuex'
import finance from './modules/finance'
import market from './modules/market'
import production from './modules/production'
Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    dateStr: '',
    isInitDateStr: true,
    pageTitle: '经营总览',
    navIndex: 0,
    popUpObj: {},
    showNav: true,
    showLeft: false,
    showMask: false,
    showBackBtn: false,
    popupShow: false,
    showDayList: false, // 是否展示筛选面板中的日列表
    isFirstPageOut: false, // 首页是否在海外标签
    yearProcess: 0,
    monthProcess: 0,
    outDate: '',
    inDate: '',
    inSzlDate: '',
    outSzlDate: '',
    productTabIndex: 0,
    unKeepAliveName: null,
    isNewsPage: false,
    isOpenNewsDetail: false,
    urlOpenNewsId: '',
    isNewsIndex: false,
    hasEnterNewsDatail: false,
    isFromShare: false,
    activeNewsItem: {}
  },
  mutations: {
    updateNewsListItem (state, payload) {
      state.activeNewsItem = payload
    },
    updataIsFromShare (state, payload) {
      state.isFromShare = payload
    },
    updateEnterNewsDatail (state, payload) {
      state.hasEnterNewsDatail = payload
    },
    updateNewsIndex (state, payload) {
      state.isNewsIndex = payload
    },
    updateUrlNewsId (state, payload) {
      state.urlOpenNewsId = payload
    },
    updataOpenNewsDetail (state, payload) {
      state.isOpenNewsDetail = payload
    },
    updateNewsPage (state, payload) {
      state.isNewsPage = payload
    },
    updateProductTab (state, payload) {
      state.productTabIndex = payload
    },
    updataPopShow (state, payload) {
      state.popupShow = payload
    },
    updataPopObj (state, payload) {
      state.popUpObj = payload
    },
    updateDateStr (state, payload) {
      state.dateStr = payload
    },
    updateInitDateStr (state, payload) {
      state.isInitDateStr = payload
    },
    updatePageTitle (state, payload) {
      state.pageTitle = payload
    },
    updateNavIndex (state, payload) {
      state.navIndex = payload
    },
    updateShowNav (state, payload) {
      state.showNav = payload
    },
    updateShowBackBtn (state, payload) {
      state.showBackBtn = payload
    },
    updateShowLeft (state, payload) {
      state.showLeft = payload
    },
    updateShowMask (state, payload) {
      state.showMask = payload
    },
    updateShowDayList (state, payload) {
      state.showDayList = payload
    },
    isFirstPageOut (state, payload) {
      state.isFirstPageOut = payload
    },
    updateYearProcess (state, payload) {
      state.yearProcess = payload
    },
    updateMonthProcess (state, payload) {
      state.monthProcess = payload
    },
    changeOutDate (state, payload) {
      state.outDate = payload
    },
    changeInDate (state, payload) {
      state.inDate = payload
    },
    updateSzlInDate (state, payload) {
      state.inSzlDate = payload
    },
    updateSzlOutDate (state, payload) {
      state.outSzlDate = payload
    },
    updateUnKeepAliveName (state, payload) {
      state.unKeepAliveName = payload
    }
  },
  actions: {},
  modules: {
    finance: finance,
    market: market,
    production: production
  }
})
